import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { useStore } from '@feathr/extender/state';

import { skeleton } from '@feathr/components/dist/style/skeleton.css';

interface IProps {
  className?: string;
  id: string;
}

function DomainLabel({ className, id }: Readonly<IProps>): JSX.Element {
  const { Domains } = useStore();
  const domain = Domains.get(id);
  return (
    <div className={classNames({ [skeleton]: domain.isPending }, className)}>{domain.name}</div>
  );
}

export default observer(DomainLabel);
